<template>
  <div class="box">
    <article class="media">
      <div class="media-content">
        <div :id="chartId" style="width:100%; height:300px;" class="has-text-centered"></div>
      </div>
    </article>
  </div>
</template>
<script>
export default {
  props: {
    data: { type: Number, required: true },
    name: { type: String, default: 'default' },
    color: { type: String },
    label: { type: String },
    maxValue: { type: Number, default: 4 }
  },
  data () {
    return {
      chartElement: null
    }
  },
  computed: {
    chartId () {
      return `donut-chart-${this.name}`
    }
  },
  mounted () {
    this.chartElement = window.echarts.init(document.getElementById(this.chartId))
    this.loadChartData(this.data)
    window.addEventListener('resize', () => {
      this.chartElement.resize()
    })
  },
  methods: {
    loadChartData (data) {
      let seriesData = []
      if (this.color) {
        seriesData = [{ value: 100, itemStyle: { color: this.color } }]
      } else {
        const a = data
        const b = this.maxValue - a
        seriesData = [
          { value: b, itemStyle: { color: '#dd2248' } },
          { value: a, itemStyle: { color: '#3ec154' } }
        ]
      }

      const label = this.label || parseFloat(data).toFixed(2)

      const options = {
        // tooltip: {
        //   trigger: 'item',
        //   formatter: '{a} <br/>{b}: {c} ({d}%)',
        // },
        series: [
          {
            name: this.title,
            type: 'pie',
            radius: ['50%', '80%'],
            avoidLabelOverlap: true,
            label: {
              color: '#000',
              fontSize: '150%',
              position: 'center',
              formatter: () => label
            },
            labelLine: {
              show: false
            },
            data: seriesData
          }
        ]
      }
      this.chartElement.setOption(options)
    }
  },
  watch: {
    data (newData) {
      if (newData && this.chartElement) {
        this.loadChartData(newData)
      }
    }
  }
}
</script>
